import { Tag } from "@sprout/tag.tsx";
import "@/stylesheets/applications/current_stage_card.scss";
import { Body } from "@sprout/typography.tsx";

interface Props {
  name: string;
  description?: string | null;
}

export const CurrentStageCard = ({ name, description }: Props) => {
  return (
    <div className="stage-card border-1 border-gray-700 rounded-md">
      <div className="flex flex-col w-fit">
        <div className="flex">
          <Tag label={"Current stage"}></Tag>
        </div>
        <Body>{name}</Body>
      </div>
      {description && (
        <div className="stage-description" dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
    </div>
  );
};
